import React, { ReactElement, FunctionComponent, RefObject } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import ListTeaserHeadline from '../../Theme/Fonts/ListTeaserHeadline'
import TeaserInfo from '../../TeaserInfo'
import { BasicTeaserType, TeaserProps, TaboolaRegionItem } from '../TeaserInterface'
import { ChannelLogoTypes } from '../../Theme/Logos/LogoInterfaces'
import LinkProps from '../../Link/LinkProps'
import VideoLabelProps from '../../BaseComponents/Labels/Video/VideoLabelProps'
import MidTeaserImage from './Image'

export type MidTeaserStreamProps = {
    type: 'STREAM'
    showTonal?: boolean
    logo?: ChannelLogoTypes
    /**
     * property for ref forwarding
     * @TJS-type React.RefObject<Element>
     * */
    innerRef?: RefObject<Element>
}

export type MidTeaserProps = (MidTeaserStreamProps | BasicTeaserType) &
    TeaserProps &
    LinkProps &
    TaboolaRegionItem &
    VideoLabelProps & {
        /** should use the full existing container size */
        expand?: boolean
        /** should use 290px width and the full vertical existing container size */
        verticalExpand?: boolean
        /** Determines how should the new tab opened on browser */
        webTarget?: '_blank' | '_self' | '_parent' | '_top' | 'framename' | string
    }

const MidTeaser: FunctionComponent<MidTeaserProps> = ({
    mainImageUrl,
    mainImageAlt,
    type,
    labels,
    videoDuration,
    headlineText,
    headlineNumberOfLines = 2,
    tag,
    published,
    onShare,
    onPress,
    backgroundColor = 'TRANSPARENT',
    textColor = 'onyx',
    testID,
    showTonal,
    logo,
    expand = false,
    verticalExpand = false,
    href,
    webTBRegionItem,
    innerRef,
    webRel,
    webTarget,
    teaserIcon,
}): ReactElement | null => {
    return (
        <Grid
            ref={innerRef}
            noExpand={!expand && !verticalExpand}
            minWidth={0}
            width={!expand ? 290 : undefined}
            flexShrink={0}
            flexBasis={expand ? 'auto' : undefined}
            backgroundColor={backgroundColor}
        >
            <Touchable
                expand={verticalExpand || expand}
                flexBasis={expand ? 'auto' : undefined}
                href={href}
                onPress={onPress}
                testID={testID}
                webRel={webRel}
                webTBRegionItem={webTBRegionItem}
                webTarget={webTarget}
            >
                <MidTeaserImage
                    labels={labels}
                    type={type}
                    imageUrl={mainImageUrl}
                    alt={mainImageAlt}
                    videoDuration={videoDuration}
                    showTonal={showTonal}
                    logo={logo}
                    expand={expand}
                    teaserIcon={teaserIcon}
                />
                <Grid
                    noExpand={!expand && !verticalExpand}
                    flexBasis={expand ? 'auto' : undefined}
                    marginY={3}
                >
                    <ListTeaserHeadline
                        numberOfLines={headlineNumberOfLines}
                        color={textColor}
                        className={webTBRegionItem === '' ? 's1-taboola-title' : undefined}
                    >
                        {headlineText}
                    </ListTeaserHeadline>
                </Grid>
            </Touchable>
            <TeaserInfo
                imageUrl={tag?.imageUrl}
                alt={tag?.imageAlt}
                published={published}
                name={tag?.name}
                onShare={onShare}
                color={textColor === 'onyx' ? 'keshi-3' : 'pearl'}
                tintColor={tag?.imageTintColor}
            />
        </Grid>
    )
}

export default MidTeaser
